module.exports = __webpack_public_path__ + "img/sushi-wbtc-tbtc.7136a7d3.svg";